<template>
  <div class="modal fade" id="Cancel" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-12 my-auto">
            <span>
              <a class="close">
                <i
                  class="far fa-times-circle fa-2x"
                  data-dismiss="modal"
                  id="closeCancelBill"
                  aria-label="Close"
                ></i>
              </a>
            </span>
          </div>
        </div>
        <div class="container-fluid">
          <!-- <form @submit.prevent="submit"> -->
          <div class="modal-body">
            <div class="container-fluid">
              <div class="row text-center mt-3">
                <div class="col-sm-12">
                  <p class="font-weight-bold">Are you sure you want to cancel this bill?</p>
                </div>
                <div class="col-sm-12 no-pad">
                  <button
                    type="submit"
                    class="btn btn-hc w-40 mr-2 mb-3"
                    :disabled="submitStatus === 'PENDING'"
                    @click="submit"
                  >Yes</button>
                  <button
                    type="submit"
                    class="btn btn-hc w-40 ml-2 mb-3"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="document.getElementById('closeCancelBill').click()"
                  >No</button>
                </div>
              </div>
            </div>
          </div>
          <!-- </form> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      submitStatus: null,
    };
  },
  computed: {
    details() {
      return this.$store.state.finances.billDetails;
    },
  },
  methods: {
    submit() {
      // do your submit logic here
      this.submitStatus = "PENDING";
      this.$http
        .put(
          "https://" +
            this.$config.honeycomb.billbotbillrun.domain +
            "/api/v1/BillRuns/undo",
          {
            BillIds: [this.details.Id],
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.submitStatus = "OK";
          if (response.data.Processed.length > 0) {
            this.$snotify.success(`Success! Bill cancelled.`);
          } else {
            this.$snotify.warning(
              `Warning! Bill cancellation failed to process.`
            );
          }
          document.getElementById("closeCancelBill").click();

          this.$store.dispatch("getBills");
          this.$store.dispatch("getLedger");
          this.$store.dispatch("getCharges");
          this.$store.dispatch("getUsage");
          this.$store.dispatch("refreshReadings");

          setTimeout(() => {
            this.$store.dispatch("refreshCustomer");
          }, 3000);
        })
        .catch((error) => {
          // Error
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            this.submitStatus = "Error";
            if (error.response.data.MoreInformation.length > 0) {
              error.response.data.MoreInformation.forEach((e) => {
                this.$snotify.error(`${e.Error}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              });
            } else {
              this.$snotify.error(`${error.response.data.UserDescription}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.submitStatus = "Error";
            this.$snotify.error(`No response received.`, {
              timeout: 0,
              closeOnClick: true,
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            this.submitStatus = "Error";
            this.$snotify.error(`${error.message}`, {
              timeout: 0,
              closeOnClick: true,
            });
          }
        });
    },
  },
};
</script>
